import { Component, OnInit,TemplateRef, ViewChild } from '@angular/core';
import {MychampService} from '../services/mychamp.service'
import {MasterService} from '../services/master.service'
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers:[MychampService,MasterService]
})
export class DashboardComponent implements OnInit {
dashslideimg:any[];
dashnotification:any[];
 dashtodo:any[];
 Myperformance:any[];
 Upcoming:any[];
 arrjobs:any=[];
 arrnotification:any=[];
 arrassign:any=[];
 arrtodo:any=[];
 tag=0;
 ipactive:any;
 closeResult: string;
 enablejob:any;
 modalOptions:NgbModalOptions;
 private modalRef: NgbModalRef;
 constructor(private mservice: MychampService,private msservice: MasterService,private modalService: NgbModal) {

  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
  }
 }

  ngOnInit(): void {
    this.enablejob=localStorage.getItem('placement');
    this.notifications('seltop');
    this.assignments('seltop');
    this.getjobposts();
    this.getactiveip();
    this.dashslideimg=[
        {
          id:"1",
          url:"assets/dist/img/photo1.png"
        },
        {
          id:"2",
          url:"assets/dist/img/photo2.png"
        },
        {
          id:"3",
          url:"assets/dist/img/photo3.jpg"
        }
    ];
this.dashnotification=[
  {id:"1",
   date:"Shared publicly - 7:45 PM today",
   for:"Message For You",
   desc:"Lorem ipsum represents a long-held tradition for designers",
   
},
{id:"1",
date:"Shared publicly - 7:45 PM today",
for:"Message For Class",
desc:"Lorem ipsum represents a long-held tradition for designers"
}
];
this.dashtodo=[
  {id:"1",
  date:"Shared publicly - 7:45 PM today",
  for:"Message For You",
  desc:"Lorem ipsum represents a long-held tradition for designers",
  due:"20/Feb/2022"
},
{id:"1",
date:"Shared publicly - 7:45 PM today",
for:"Message For Class",
desc:"Lorem ipsum represents a long-held tradition for designers",
due:"20/Feb/2022"
}

];
this.Upcoming=[];
  }

  getjobposts() {
    this.mservice.getjobposts()
        .subscribe( 
        resultArray => {
            console.log('arrjobs', resultArray);
            this.arrjobs = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  confirm_apply(jbid,jpdid)
  {
if(confirm("Are You Sure ? You wan't to apply.."))
{
  if (jpdid==null || jpdid=='')
  {
    this.applycanceljob(jbid,'apply');
  }

  else{
  this.applycanceljob(jpdid,'reapply');
  }
}
  }

  confirm_cancel(jbid)
  {
if(confirm("Are You Sure ? You wan't to Cancel.."))
{
  this.applycanceljob(jbid,'cancel');
}
  }

  applycanceljob(jid,oprtype) {
    var pstdata={jpid:jid,oprtype:oprtype};
    this.mservice.applycanceljob(pstdata)
        .subscribe( 
        resultArray => {
            console.log('arrjobs', resultArray);
           alert(resultArray.message);

           this.getjobposts();

        },
        error => console.log("Error :: " + error)
        )
  }

  notifications(oprtype) {
    //var pstdata={jpid:jid,oprtype:oprtype};
    this.mservice.notifications(oprtype)
        .subscribe( 
        resultArray => {
            console.log('arrjobs', resultArray);
           this.arrnotification=resultArray.details;

        },
        error => console.log("Error :: " + error)
        )
  }

  todolist(oprtype) {
    //var pstdata={jpid:jid,oprtype:oprtype};
    this.mservice.todoevents(oprtype)
        .subscribe( 
        resultArray => {
            console.log('arrjobs', resultArray);
           this.arrtodo=resultArray.eventlst;

        },
        error => console.log("Error :: " + error)
        )
  }

  
  assignments(oprtype) {
    //var pstdata={jpid:jid,oprtype:oprtype};
    this.mservice.assignments(oprtype)
        .subscribe( 
        resultArray => {
            console.log('assignments', resultArray);
           this.arrassign=resultArray.details;
           this.todolist(oprtype);

        },
        error => console.log("Error :: " + error)
        )
  }

  openlink(url:string){
  debugger
  let substr= 'http://';
  let substr1= 'https://';
 const result= url.indexOf(substr.toLowerCase());
 const result2= url.indexOf(substr1.toLowerCase());
var openurl="";
if(result!= -1 || result2!= -1)
{
   window.open(url);
}
else 
{
  window.open(substr+url);
}
 }

 openfiles(url:string){
  debugger
  window.open(this.ipactive+url);
 }

 getactiveip()
 {
   this.msservice.getipurl()
   .subscribe(
          resultArray =>{
  // this.liservice.Getdashboarddata('dashcounts')
     console.log('result-dashcounts',resultArray) ;
     this.ipactive=resultArray;
     
     //this.getprofiledata();

     },
    error => console.log('Error :: ' + error)
 );
 }

}
